import { Button } from '@/components/Button/Button';
import { Ionicons } from '@expo/vector-icons';
import { SizableText, useTheme, XStack, YStack } from 'tamagui';
import type { UploadedFileItemProps } from './fileUploaderField.types';
import { formatFileSize, getIconName } from './fileUploaderField.utils';

export const UploadedFileItem = ({
  file,
  onRemove,
}: UploadedFileItemProps): React.ReactElement => {
  const theme = useTheme();
  const iconColor = theme.color?.val ?? '#27282A';
  const errorColor = theme.$error?.val ?? '#F93B34';

  return (
    <XStack alignItems="center" justifyContent="space-between">
      <XStack alignItems="center" gap="$3" flex={1}>
        <YStack
          backgroundColor="$tertiary50"
          padding="$2"
          borderRadius="$circle"
        >
          <Ionicons name={getIconName(file)} size={16} color={iconColor} />
        </YStack>
        <YStack flex={1}>
          <SizableText size="$2" numberOfLines={1}>
            {file.name}
          </SizableText>
          <SizableText size="$3" color="$secondary75">
            {formatFileSize(file.size)}
          </SizableText>
        </YStack>
      </XStack>

      <Button
        variant="outlined-destructive"
        icon={<Ionicons name="trash-outline" size={20} color={errorColor} />}
        onPress={onRemove}
      />
    </XStack>
  );
};
